import { render, staticRenderFns } from "./RateRadio.vue?vue&type=template&id=73fa48d1&scoped=true"
import script from "./RateRadio.vue?vue&type=script&lang=js"
export * from "./RateRadio.vue?vue&type=script&lang=js"
import style0 from "./RateRadio.vue?vue&type=style&index=0&id=73fa48d1&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fa48d1",
  null
  
)

export default component.exports